import { useEffect, useState } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Profile } from "@/models/database/profiles/profile.model";
import { timestamp } from "@/api/firebase/firebase.config";

export const useTenantProfilesCount = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [count, setCount] = useState<Number>();

  const fetchProfiles = async () => {
    try {
      setLoading(true);
      const profiles: Profile[] = [];

      const ref = collectionRef.profiles(brand.tenantId);
      const query = await ref.get();

      query.docs.map(async (doc) => {
        profiles.push(doc.data());
      });

      const numberOfProfiles = profiles.length;
      setCount(numberOfProfiles);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!count) {
      fetchProfiles();
    }
  }, [brand.tenantId]);

  return {
    data: count,
    loading,
    error,
  };
};
